import { useEffect, useState } from 'react';

export function useVisibilityChange() {
  const [isTabHidden, setIsTabHidden] = useState(() => document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabHidden(document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { isTabHidden };
}
